module.exports = __webpack_public_path__ + "img/maintop.b7f7ad9.png";